
import Lottie from "lottie-react";
import { useEffect } from "react";
import { View, StyleProp, ViewStyle } from "react-native";

interface Props {
  source: any;
  autoPlay?: boolean;
  loop?: boolean;
  style?: StyleProp<ViewStyle>;
  resizeMode?: "cover" | "contain" | "center";
}

export default function LottieWeb({
  source,
  autoPlay = true,
  loop = true,
  style,
  resizeMode = "contain",
}: Props) {


  return (
    <View style={[style, { overflow: "hidden" }]}>
      <Lottie
        animationData={source}
        loop={loop}
        autoplay={autoPlay}
        style={{
          width: "100%",
          height: "100%",
          objectFit: resizeMode,
        } as any}
      />
    </View>
  );
}
